"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsQuickBetActive = exports.selectQuickBetStatusByOutcomeId = void 0;
const constants_1 = require("./constants");
const selectQuickBetStatusByOutcomeId = (state, id) => {
    var _a;
    return (_a = state.betsProvider.quickBetStatus[id]) !== null && _a !== void 0 ? _a : constants_1.emptyQuickBetStatus;
};
exports.selectQuickBetStatusByOutcomeId = selectQuickBetStatusByOutcomeId;
const selectIsQuickBetActive = (state) => {
    return state.betsProvider.isQuickBetActive;
};
exports.selectIsQuickBetActive = selectIsQuickBetActive;
//# sourceMappingURL=selectors.js.map